import React, { useState, useEffect, useRef } from 'react'
import { HiDownload } from "react-icons/hi";
import { GoPlus } from "react-icons/go";
import { RiDeleteBinLine } from "react-icons/ri";
import { FiEdit2, FiLink, FiMail } from "react-icons/fi";
import { toast } from 'react-toastify';
import ListPopup from './list-show-all-popup';
import { apiCallingPost, apiCallingGetDecrypted } from '../../api/services';
import { MdOutlineZoomOutMap, MdOutlinePlayCircle, MdTune, MdKeyboardArrowRight, MdKeyboardArrowLeft } from "react-icons/md";
import ListReject from './list-reject';
import ListUpload from './list-upload';
import Loader from "../../assets/images/loader.gif"
import { IoShareSocialOutline } from "react-icons/io5";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedQuality, setCurrentPlaybackRate, setViewType, setVolume, setIsMuted } from '../../redux/reducers/commonSliceWhiteList';
import { IoSettingsSharp, IoLocationOutline } from "react-icons/io5";
import { MdOutlinePermMedia } from "react-icons/md";
import { GrMultimedia } from "react-icons/gr";
import { CiCalendarDate } from "react-icons/ci";
import { IoIosResize } from "react-icons/io";
import { debounce } from 'lodash';
import moment from 'moment';
import { IoCloseOutline } from "react-icons/io5";
import { FaDownload, FaEye } from "react-icons/fa";
import { RiLoader4Fill } from "react-icons/ri";
import { MdPictureInPicture, MdCloseFullscreen } from "react-icons/md";
import { BiDownload, BiFile } from "react-icons/bi";

let url

function List(props) {
  const dispatch = useDispatch();
  const { selectedQuality, currentPlaybackRate, speeds, viewType, volume, isMuted } = useSelector((state) => state.commonDataWhiteList);
  const videoRefs = useRef({});
  const shareIconsRef = useRef(null);
  const [tagPopupFlag, setTagPopupFlag] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [popupList, setPopupList] = useState(false);
  const [popupShareStates, setPopupShareStates] = useState({});
  const [popupReject, setPopupReject] = useState(false);
  const [rejectData, setRejectData] = useState([]);
  const [mode, setMode] = useState("");
  const [selectIndex, setSelectIndex] = useState("");
  const [speedFlag, setSpeedFlag] = useState(true);
  const [selectData, setSelectData] = useState([]);
  const [hoveredVideoId, setHoveredVideoId] = useState(null);
  const dropdownRef = useRef(null);
  const [activeSettings, setActiveSettings] = useState(null);
  const [quality, setQuality] = useState(true);
  const popupRef = useRef(null);
  const popupRefList = useRef(null);
  const [activeShareIndex, setActiveShareIndex] = useState(null);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [isShareLink, setIsShareLink] = useState(false)
  const [shareMode, setShareMode] = useState("Viewer")
  const [isDownload, setIsDownload] = useState(false)
  const [isOriginalCheck, setIsOriginalCheck] = useState(false);
  const [isMp4Check, setIsMp4check] = useState(false)
  const [selectedDownloadVideo, setSelectedDownloadVideo] = useState([]);
  const [selectedDownloadVideoALL, setSelectedDownloadVideoALL] = useState([]);
  const [selectedDownloadVideoMode, setSelectedDownloadVideoMode] = useState("Single");
  const [pipVideoId, setPipVideoId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [videoIDsIndividual, setVideoIDsIndividual] = useState([]);
  const [isMultipleDownload, setIsMultipleDownload] = useState(false);
  const [selectedQualities, setSelectedQualities] = useState({});
  const [totalFileSize, setTotalFileSize] = useState(0)
  const [isDownloadBtn, setIsDownloadBtn] = useState(false)
  const [isVideoFormatSelect, setIsVideoFormatSelect] = useState(true)
  const [selectedItems, setSelectedItems] = useState([]);
  const [hasVideo, setHasVideo] = useState(false);
  const [isDelete, setIsDelete] = useState(false)
  const [selectedToDelete, setSelectedToDelete] = useState(null);
  const [individualDownloadVideo, setIndividualDownloadVideo] = useState([]);
  const [isSingleDownload, setIsSingleDownload] = useState(true)
  useEffect(() => {

    const handleClickOutside = (event) => {
      // Close share list popup
      if (popupRefList.current && !popupRefList.current.contains(event.target)) {
        setActiveShareIndex(null);
      }

      // Close share icons popup
      if (shareIconsRef.current && !shareIconsRef.current.contains(event.target)) {
        setPopupShareStates({});
      }

      // Close video settings popups
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setActiveSettings(null);
        setSpeedFlag(true);
        setQuality(true);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleVideoQualityChange = (videoId, selectedQuality, sizes) => {
    const selectedVideoSize = sizes.find(q => q.qualitytype === selectedQuality)?.qualityvideosize || 0;

    setSelectedQualities(prev => {
      const updated = {
        ...prev,
        [videoId]: { quality: selectedQuality, size: selectedVideoSize }
      };
      // Update total size
      const totalSizeMB = selectedDownloadVideo.reduce((sum, video) => {
        const selected = updated[video.video_id];
        return sum + (selected?.size ? Number(selected.size) : Number(video.size.split(' ')[0]));
      }, 0);
      const formattedSize = getTotalSizeMB(totalSizeMB.toFixed(2));
      setTotalFileSize(formattedSize);
      return updated;
    });
  };

  const handleQualityChange = (quality) => {
    // Save selected quality globally
    dispatch(setSelectedQuality(quality));
    // If there's a currently hovered video, update *only that one* on-the-fly
    if (hoveredVideoId) {
      const list = props.destinationList.find(
        (l) => l.video_id === hoveredVideoId
      );
      const videoElement = videoRefs.current[hoveredVideoId];
      if (list && videoElement) {
        const newSrc =
          list?.qualityTypeArray?.find((q) => q.qualitytype === quality)?.qualityvideoname ||
          list.url;
        if (newSrc && videoElement.src !== newSrc) {
          const wasPlaying = !videoElement.paused;
          const currentTime = videoElement.currentTime;
          videoElement.src = newSrc;
          videoElement.load();
          videoElement.onloadeddata = () => {
            videoElement.currentTime = currentTime;
            if (wasPlaying) {
              videoElement.play().catch(console.error);
            }
          };
        }
      }
      setActiveSettings(false);
    }

  };

  const toggleSettings = (videoId) => {
    setActiveSettings(activeSettings == videoId ? null : videoId);
    setHoveredVideoId(null);
    setSpeedFlag(true);
    setQuality(true);
  };

  const popupTagShow = (data) => {
    setSelectedData(data);
    setTagPopupFlag(true);
    document.body.style.overflow = 'hidden';
  };

  const approveList = async (data) => {
    let postData = {
      videoId: [data.video_id],
      userId: props?.userData?.userId
    };
    try {
      const { data: responseData } = await apiCallingPost("api/video/approveVideo", postData);
      if (responseData.success === "1") {
        toast.success(`Media Approved successfully.`);
        let jsonMailOptions = responseData.result;
        setTimeout(() => {
          props.getData("", "");
        }, 1000);
      } else {
        toast.error(`Something went wrong.`);
      }
    } catch (error) {
      console.error("Error Approved Video:", error);
    }
  };

  const deleteList = async (data) => {
    // if (window.confirm("Do you want to delete?")) {
    if (!selectedToDelete) return;
    let postData = {
      videoIds: [selectedToDelete.video_id],
      userId: props.userData.userId
    };
    try {
      const { data: responseData } = await apiCallingPost("api/video/deleteVideo", postData);
      if (responseData.success === "1") {
        toast.success(`Media deleted successfully.`);
        setTimeout(() => {
          props.getData("", "");
        }, 1000);
      } else {
        toast.error(`Something went wrong.`);
      }
    } catch (error) {
      console.error("Error Deleting Video:", error);
    }
    deletePopupCancel();
    // }
  };

  const sendMail = async (mailData) => {
    let postData = {
      functionName: "sendMailToUsers",
      jsonMailOptions: mailData
    };
    try {
      await apiCallingPost(postData);
    } catch (error) {
      console.error("Error sending mail:", error);
    }
  };
  const convertToMB = (sizeStr) => {
    const match = sizeStr.match(/([\d.]+)\s*(MB|GB|TB)/i);
    if (!match) return 0;

    const value = parseFloat(match[1]);
    const unit = match[2].toUpperCase();

    switch (unit) {
      case "TB":
        return value * 1024 * 1024;
      case "GB":
        return value * 1024;
      case "MB":
      default:
        return value;
    }
  };
  const downloadMultiple = async () => {
    // if (props.userData.roleDisplayName === "User" && props?.userData?.hasFullAccess) {
    if (props?.userData?.hasFullAccess) {
      const uniqueVideos = [...new Map(selectedDownloadVideoALL.map(item => [item.video_id, item])).values()];
      setSelectedDownloadVideoALL(uniqueVideos);
      setSelectedDownloadVideoMode("Multiple")
      setIsMultipleDownload(true);
    } else
      // if (props.userData.roleDisplayName === "User" && !props?.userData?.hasFullAccess) {
      if (!props?.userData?.hasFullAccess) {
        setSelectedDownloadVideoMode("Multiple")

        const pendingOrRejected = [];
        const approvedVideos = [];
        const openVideos = [];

        (selectedDownloadVideoALL || []).forEach((video) => {
          if (video.downloadStatus === "" || video.downloadStatus === "REJECTED") {
            pendingOrRejected.push(video.video_id);
          } else if (video.downloadStatus === "OPEN") {
            openVideos.push(video.video_id);
          } else {
            approvedVideos.push(video);
          }
        });

        const total = selectedDownloadVideoALL.length;

        if (approvedVideos.length === total) {
          setSelectedDownloadVideoALL(approvedVideos);
          setIsMultipleDownload(true);
          return;
        }

        if (openVideos.length === total) {
          toast.warn("All videos are currently pending approval.");
          return;
        }

        if (pendingOrRejected.length === total) {
          const postData = {
            video_id: pendingOrRejected,
            user_id: props.userData.userId,
            created_on: new Date().getTime(),
          };

          try {
            const { data: responseData } = await apiCallingPost(
              "api/video/saveVideoDownloadRequest",
              postData
            );

            if (responseData.success === "1") {
              toast.success("Approval requests have been sent for all videos.");
              props.getData("", "");
            }
          } catch (error) {
            console.error("Error submitting download request:", error);
          }
          return;
        }

        // Handle mixed cases
        if (approvedVideos.length > 0) {
          setSelectedDownloadVideoALL(approvedVideos);
          setIsMultipleDownload(true);
        }

        let messageParts = [];

        if (approvedVideos.length > 0) {
          messageParts.push(`${approvedVideos.length} ${approvedVideos.length === 1 ? "video is" : "videos are"} approved`);
        }

        if (openVideos.length > 0) {
          messageParts.push(`${openVideos.length} ${openVideos.length === 1 ? "is" : "are"} pending approval`);
        }

        if (pendingOrRejected.length > 0) {
          const postData = {
            video_id: pendingOrRejected,
            user_id: props.userData.userId,
            created_on: new Date().getTime(),
          };

          try {
            const { data: responseData } = await apiCallingPost(
              "api/video/saveVideoDownloadRequest",
              postData
            );

            if (responseData.success === "1") {
              messageParts.push(`approval requests have been sent for ${pendingOrRejected.length} ${pendingOrRejected.length === 1 ? "video" : "videos"}`);
              toast.success(messageParts.join(", ") + ".");
              props.getData("", "");
            }
          } catch (error) {
            console.error("Error submitting download request:", error);
          }
        } else {
          // If nothing new to request, still show toast if needed
          if (messageParts.length > 0) {
            toast.warn(messageParts.join(", ") + ".");
          }
        }
      }
  };


  const getTotalSizeInMB = (videoArray) => {
    let totalSize = 0;
    videoArray.forEach(video => {
      let sizeInMB;
      if (video.download_original || video.download_original === "" || props?.userData?.hasFullAccess) {
        // Use original size from `videoObj.size`
        sizeInMB = parseFloat(video.size);
        setSelectedQualities(prev => {
          const updated = {
            ...prev,
            [video.video_id]: { quality: "Download Original", size: sizeInMB }
          };
          return updated;
        });
      } else if (Array.isArray(video.qualityvariants) && video.qualityvariants.length > 0) {

        // Use the first quality variant size
        sizeInMB = parseFloat(video.qualityvariants[0].qualityvideosize);
        setSelectedQualities(prev => {
          const updated = {
            ...prev,
            [video.video_id]: { quality: video.qualityvariants[0].qualitytype, size: sizeInMB }
          };
          return updated;
        });
      } else {
        sizeInMB = 0; // fallback
      }
      const sizeString = sizeInMB.toString().trim().toUpperCase(); // Ensure "MB"
      const value = parseFloat(sizeString.replace("MB", ""));
      totalSize += isNaN(value) ? 0 : value;
    });
    return totalSize.toFixed(2); // Round to 2 decimals
  };

  const handleDownloadAll = async () => {
    const selectedResolutionArray = getSelectedQualityArray();
    const encoded = encodeURIComponent(JSON.stringify(selectedResolutionArray));

    const { responseData } = await apiCallingGetDecrypted(`api/download/download_zip?videoId=${encoded}`);
    const link = document.createElement('a');
    link.href = responseData;
    link.download = "video.zip" // optional: helps some browsers
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  const getSelectedQualityArray = () => {
    return selectedDownloadVideo.map((video) => {
      const selected = selectedQualities[video.video_id];
      return {
        fileId: video.video_id,
        type: selected?.quality === "Download Original" || !selected?.quality ? "" : selected.quality,
      };
    });
  };
  const downloadSingle = async (videoObj, i) => {
    if (videoObj.downloadStatus === "APPROVED" || props?.userData?.hasFullAccess) {
      //  setIsSingleDownload(true)
      setSelectedDownloadVideoMode("Single")
      setIsMultipleDownload(true)
      // setIndividualDownloadVideo(videoObj);
      setSelectedDownloadVideo([videoObj]);


      // Determine size based on `download_original`
      let sizeInMB;
      if (videoObj.download_original || videoObj.download_original === "" || props?.userData?.hasFullAccess) {
        // Use original size from `videoObj.size`
        sizeInMB = parseFloat(videoObj.size);

      } else if (Array.isArray(videoObj.qualityvariants) && videoObj.qualityvariants.length > 0) {
        // Use the first quality variant size
        sizeInMB = parseFloat(videoObj.qualityvariants[0].qualityvideosize);
        // const formattedSize = getTotalSizeMB(sizeInMB);
        setSelectedQualities(prev => {
          const updated = {
            ...prev,
            [videoObj.video_id]: { quality: videoObj.qualityvariants[0].qualitytype, size: sizeInMB }
          };
          return updated;
        });
      } else {
        sizeInMB = 0; // fallback
      }
      const formattedSize = getTotalSizeMB(sizeInMB);
      setTotalFileSize(formattedSize);
      setIsDownloadBtn(true)

    } else
      if (props.userData.roleDisplayName === "User" && (videoObj.downloadStatus === "" || videoObj.downloadStatus === "REJECTED")) {
        const postData = {
          video_id: [videoObj.video_id],
          user_id: props.userData.userId,
          created_on: new Date().getTime(),
        };

        try {
          const { data: responseData } = await apiCallingPost(
            "api/video/saveVideoDownloadRequest",
            postData
          );

          if (responseData.success === "1") {
            toast.success("Media download request submitted.");
            props.getData("", "");
          }
        } catch (error) {
          console.error("Error submitting download request:", error);
        }
      } else if (videoObj.downloadStatus === "OPEN") {
        toast.warning("You already sent a request.");
      }
    // else {
    //   setIsMultipleDownload(true)
    //   setSelectedDownloadVideo([videoObj]);
    //   const formattedSize = getTotalSizeMB(videoObj.size);
    //   setTotalFileSize(formattedSize)
    //   setIsDownloadBtn(true)
    // }


  }
  const handleSingleDownload = async (video, selectedQualityObj) => {

    const resolutionType = selectedQualityObj?.quality === "Download Original" || !selectedQualityObj?.quality
      ? ""
      : selectedQualityObj.quality;
    const requestPayload = [{
      fileId: video.video_id,
      type: resolutionType
    }];
    const encoded = encodeURIComponent(JSON.stringify(requestPayload));
    try {
      const { responseData } = await apiCallingGetDecrypted(`api/download/download_zip?videoId=${encoded}`);
      const link = document.createElement('a');
      link.href = responseData;
      link.download = `${video.filename}.${video.file_extension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Single download failed", err);
    }
  };


  const downloadAll = async () => {
    setIsLoading(true)
    let postData = {
      video_id: selectedDownloadVideo,
      user_id: props.userData.userId
    };

    try {
      const { data: responseData } = await apiCallingPost("api/video/download_all", postData);

      if (responseData.success === "1") {
        toast.success(responseData.successMessage);

        const link = document.createElement('a');
        link.href = responseData.zipUrl;
        link.download = 'videos.zip'; // optional: helps some browsers
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => {
          props.getData("", "");
          setIsLoading(false)
          setSelectedDownloadVideo([])
        }, 1000);
      } else {
        toast.error(`Something went wrong.`);
      }
    } catch (error) {
      console.error("Error Downloading all Videos:", error);
    }

  }
  const downloadFn = async (data, i) => {

    if (!props.isAuthenticated) return (window.location.href = "/login");

    const loaderBtn = document.getElementById(`loader-btn${i}`);
    const downloadBtn = document.getElementById(`download-btn${i}`);

    if (data.downloadStatus === "APPROVED" || props?.userData?.hasFullAccess) {
      loaderBtn && (loaderBtn.style.display = "block");
      downloadBtn && (downloadBtn.style.display = "none");

      try {
        const selectedQualityUrl = data?.url;
        const response = await fetch(selectedQualityUrl);
        if (!response.ok) throw new Error("File download failed!");

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = selectedQualityUrl.split('/').pop();
        document.body.appendChild(anchor);
        anchor.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(anchor);
      } catch (error) {
        console.error("Download error:", error);
      } finally {
        loaderBtn && (loaderBtn.style.display = "none");
        downloadBtn && (downloadBtn.style.display = "block");
      }
    } else if (data.downloadStatus === "" || data.downloadStatus === "REJECTED") {
      const postData = {
        video_id: [data.video_id],
        user_id: props.userData.userId,
        created_on: new Date().getTime(),
      };
      try {
        const { data: responseData } = await apiCallingPost(
          "api/video/saveVideoDownloadRequest",
          postData
        );
        if (responseData.success === "1") {
          toast.success("Media download request submitted.");
          props.getData("", "");
        }
      } catch (error) {
        console.error("Error submitting download request:", error);
      }
    } else if (data.downloadStatus === "OPEN") {
      toast.warning("You already sent a request.");
    }
  };

  const listPopup = (data, mode, index) => {
    setPopupList(true);
    setMode(mode);
    setSelectIndex(index);
    setSelectData(data);
    document.body.style.overflow = 'hidden';
  };

  const listSharePopup = async (ids, mode, list, index) => {

    const heading = list?.video_heading || '';
    const description = list?.description || '';
    let body = '';

    if (index !== undefined) {
      body = `Hi,

     ${heading}

      ${description ? `Description: ${description}\n\n` : ''}
      View it here: ${url}

      Best regards,
      Qatar`;
    } else {
      body = `Hi,
      View it here: ${url}

      Best regards,
      Qatar`;
    }

    const encodedBody = encodeURIComponent(body);
    shareMedia(ids, url, mode, heading, encodedBody, index)
  };

  const shareMedia = async (ids, url, mode, heading, encodedBody, index) => {
    let postData = {
      videoId: ids,
      userId: props.userData.userId,
      requestedOn: new Date().getTime(),
      encodedVideoUrl: url,
      mode: shareMode,
      downloadOriginal: isOriginalCheck,//1 or 0
      downloadMp4: isMp4Check//1 or 0
    };

    try {
      const { data: responseData } = await apiCallingPost("api/video/saveShareRequest", postData);

      if (responseData.success === "1") {
        if (mode == "mail") {
          window.location.href = `mailto:someone@example.com?subject=${encodeURIComponent(heading || 'Qatar')}&body=${encodedBody}`;
        }
        if (index !== undefined) {
          setPopupShareStates((prevStates) => ({
            ...prevStates,
            [index]: !prevStates[index],
          }));
        }
      } else {
        toast.error("Please try again.");
      }
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  }

  const linkCopy = (ids, mode, list, index) => {
    if (!isOriginalCheck && !isMp4Check && isDownload && hasVideo) {
      setIsVideoFormatSelect(false)
      document.getElementById("originalVedioCheck")
      return;
    } else {
      if (isDownload) {
        setIsVideoFormatSelect(true)
      }
      setShareMode("Viewer")
      let videoIds = (ids.length > 0 ? ids : videoIDsIndividual)
      shareMedia(videoIds, url, mode)
      const shareElement = document.getElementById("link-copy-common");
      if (shareElement && isVideoFormatSelect) {
        shareElement.classList.toggle("d-none");
        setTimeout(() => {
          shareElement.classList.toggle("d-none")
          cancelPopup()
        }
          , 1500);
      }
      navigator.clipboard.writeText(url)
        .then(() => {
          // setCopiedIndex(list.video_id);
          setTimeout(() => {
            setCopiedIndex(null)
            // props.setSelectedVideoIds([]);
            // setSelectedItems([]);
          }
            , 1500);
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    }

  };

  const handleCheckboxChange = (e, videoId, fileTypeId, videoObj) => {
    setVideoIDsIndividual([])
    // if (e.target.checked) {
    //   props.setSelectedVideoIds([...props.selectedVideoIds, videoId]);
    // } else {
    //   props.setSelectedVideoIds(props.selectedVideoIds.filter(id => id !== videoId));
    //   const shareElement = document.getElementById("share-common");
    //   if (shareElement) {
    //     shareElement.classList.add("d-none");
    //   }
    // }
    if (e.target.checked) {
      setSelectedDownloadVideoALL(prev => [...prev, videoObj]);
    } else {
      setSelectedDownloadVideoALL(prev => prev.filter(item => item.video_id !== videoObj.video_id));
    }
    let updatedIds = [...props.selectedVideoIds];
    let updatedItems = [...selectedItems];

    if (e.target.checked) {
      updatedIds.push(videoId);
      updatedItems.push({ video_id: videoId, type_flag: fileTypeId });
    } else {
      updatedIds = updatedIds.filter(id => id !== videoId);
      updatedItems = updatedItems.filter(item => item.video_id !== videoId);

      const shareElement = document.getElementById("share-common");
      if (shareElement) {
        shareElement.classList.add("d-none");
      }
    }

    // Update states
    props.setSelectedVideoIds(updatedIds);
    setSelectedItems(updatedItems);

    // Set flags
    //const hasImage = updatedItems.some(item => item.type_flag === 1);
    const hasVideo = updatedItems.some(item => item.type_flag === 2);
    setHasVideo(hasVideo)

  };
  const handledownloadCheckboxChange = (e, videoObj) => {
    if (e.target.checked) {
      setSelectedDownloadVideo(prev => [...prev, videoObj]);
    } else {
      setSelectedDownloadVideo(prev => prev.filter(item => item.video_id !== videoObj.video_id));
    }

  }
  const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  const rejectPopup = (data) => {
    setRejectData(data);
    setPopupReject(true);
    document.body.style.overflow = 'hidden';
  };

  const cancelPopup = () => {
    setPopupList(false);
    setPopupReject(false);
    setTagPopupFlag(false);
    setIsShareLink(false);
    setIsDownload(false)
    setIsMp4check(false);
    setIsOriginalCheck(false)
    setIsVideoFormatSelect(true)
    document.body.style.overflow = 'auto';
    props.setSelectedVideoIds([]);
    setSelectedItems([]);
  };

  const handleMouseEnter = (data) => {
    setHoveredVideoId(data.video_id);
    const videoElement = videoRefs.current[data.video_id];
    if (videoElement) {
      const list = props.destinationList.find((l) => l.video_id === data.video_id);
      if (list) {
        const videoSrc =
          list?.qualityTypeArray?.find(
            (item) => item.qualitytype === selectedQuality
          )?.qualityvideoname || list?.url;

        // Set the src only when hovered
        if (videoElement.src !== videoSrc) {
          videoElement.src = videoSrc;
          videoElement.load();
        }
      }

      // Start playing preview
      videoElement.play().catch((err) => console.error(err));
    }
  };

  const handleMouseLeave = (videoId) => {
    setHoveredVideoId(null);
    setActiveSettings(null);
    setSpeedFlag(true);
    setQuality(true);

    const videoElement = videoRefs.current[videoId];
    if (videoElement) {
      videoElement.pause();
      // Keep the currentTime and src intact so it resumes where left
      // Remove these lines:
      // videoElement.currentTime = 0;
      // videoElement.removeAttribute('src');
      // videoElement.load();
    }
  };

  const handlePlaybackRateChange = (rate, videoId, isIndividual = false) => {
    if (isIndividual) {

      const video = videoRefs.current[videoId];
      if (video) {
        const wasPlaying = !video.paused;
        const currentTime = video.currentTime;

        video.playbackRate = rate;

        if (wasPlaying) {
          video.play().catch(error => {
            console.error("Error playing video:", error);
          });
        }
        video.currentTime = currentTime;
      }
    } else {
      dispatch(setCurrentPlaybackRate(rate));

      Object.keys(videoRefs.current).forEach((id) => {
        const video = videoRefs.current[id];
        if (video) {
          const wasPlaying = !video.paused;
          const currentTime = video.currentTime;

          video.playbackRate = rate;

          if (wasPlaying) {
            video.play().catch(error => {
              console.error("Error playing video:", error);
            });
          }
          video.currentTime = currentTime;
        }
      });
      setActiveSettings(false);
    }

  };

  const showSpeed = () => {
    setSpeedFlag(!speedFlag);
  };

  const backToList = () => {
    setSpeedFlag(true);
  };

  const showQuality = () => {
    setQuality(!quality);
  };

  const backToQuality = () => {
    setQuality(true);
  };

  const handleVolumeChange = (e) => {
    dispatch(setVolume(e.target.volume));
    dispatch(setIsMuted(e.target.muted));
  };
  const handlePiP = async (videoId) => {
    const videoElement = videoRefs.current[videoId];

    if (!document.pictureInPictureElement) {
      try {
        await videoElement.requestPictureInPicture();
        setPipVideoId(videoId);
      } catch (error) {
        console.error('Failed to enter PiP:', error);
      }
    } else {
      try {
        await document.exitPictureInPicture();
        setPipVideoId(null);
      } catch (error) {
        console.error('Failed to exit PiP:', error);
      }
    }
  };
  useEffect(() => {
    Object.values(videoRefs.current).forEach(video => {
      if (video) {
        video.volume = (typeof volume === 'number' && !isNaN(volume) ? Math.min(Math.max(volume, 0), 1) : 1);;
        video.muted = isMuted;
      }
    });
  }, [volume, isMuted]);
  const getTotalSizeMB = (mb) => {
    if (mb >= 1024 * 1024) return `${(mb / (1024 * 1024)).toFixed(2)} TB`;
    if (mb >= 1024) return `${(mb / 1024).toFixed(2)} GB`;
    return `${mb} MB`;
  };
  const cancelpopup = () => {
    setIsMultipleDownload(false)
    // if(individualDownloadVideo.length > 0){
    //   setSelectedDownloadVideo(prev => prev.filter(item => item.video_id !== individualDownloadVideo[0].video_id));
    //  setIndividualDownloadVideo([])
    // }
    //  if(isSingleDownload){
    //  setSelectedDownloadVideo([])
    //  setSelectedItems([]);
    //  }

    //setSelectedDownloadVideo([])
    // setIsSingleDownload(false)
    setSelectedQualities({})
    setIsDownloadBtn(false)
    setIsVideoFormatSelect(true)
    setShareMode("Viewer")
  }

  useEffect(() => {
    const shareElement = document.getElementById("link-copy-common");
    if (shareElement && isVideoFormatSelect) {
      shareElement.classList.toggle("d-none");
      setTimeout(() => {
        shareElement.classList.toggle("d-none")
        cancelPopup()
      }
        , 1500);
    }
  }, [isVideoFormatSelect]);

  useEffect(() => {
    const total = getTotalSizeInMB(selectedDownloadVideoALL);
    const formattedSize = getTotalSizeMB(total);
    setTotalFileSize(formattedSize)
  }, [selectedDownloadVideoALL]);

  const deletePopupCancel = () => {
    setIsDelete(false)
    setSelectedToDelete(null);
  }
  return (
    <div className="list-wrapper my-5">

      <div className='container'>
        <div className="row align-items-center">
          <div className='col-md-12 col-lg-4 col-12'>
            <h2 className='main-head'>Moments in Motion</h2>
          </div>
          <div className='col-md-12 text-end col-lg-8 col-12'>
            <div className="row">
              <div className="col-lg-12 filter-section">
                {(selectedDownloadVideoALL.length > 0) &&
                  <button className="btn-listing-btn" onClick={() => downloadMultiple()}
                  // onClick={() => downloadAll()}
                  >
                    {/* {isLoading ?
                      (<RiLoader4Fill className="loader-icon" />) : */}
                    <HiDownload />
                    {/* } */}
                  </button>}

                {((props.selectedVideoIds.length > 0 || videoIDsIndividual.length > 0)) && (
                  <>
                    {isShareLink &&
                      <div className="modal-admin-wrapper multiple-upload" >
                        <div className="modal-ad-popup modal-md">
                          <span className="closeBtn closeBtn_file">
                            <IoCloseOutline onClick={() => cancelPopup()} size={32} />
                          </span>
                          <div className="modal-innerpopup">

                            <div className="row mb-3">
                              <div className='col-lg-8 col-6'>
                                <h5 className="modal-head mb-0 text-start mt-2">Anyone with the link</h5>
                              </div>
                              <div className='col-lg-4 col-6 '>
                                <select name="" id="" className='form-control form-select-drop' onChange={(e) => {
                                  setShareMode(e.target.value)
                                  if (e.target.value === "Download") {
                                    setIsDownload(true)
                                  } else {
                                    setIsDownload(false)
                                  }
                                }} >
                                  <option value="Viewer" selected >View only</option>
                                  <option value="Download">Download</option>
                                </select>
                                {/* {isDownload && */}

                                <div style={{ visibility: isDownload && hasVideo ? 'visible' : 'hidden' }}>
                                  <div className="checkbox-wrapper-1 checkbox-list-select d-flex align-items-center gap-3 mt-2">
                                    <div className='d-flex align-items-center gap-1'>
                                      <input id={`originalVedioCheck`} className="substituted" type="checkbox" aria-hidden="true"
                                        checked={isOriginalCheck}
                                        onChange={(e) => setIsOriginalCheck(e.target.checked)}
                                      />
                                      <label className=" d-flex align-items-center" htmlFor={`originalVedioCheck`}
                                        style={{ fontSize: '12px' }}
                                      >Original</label>
                                    </div>
                                    <div className='d-flex align-items-center gap-1'>
                                      <input id={`mp4Check`} className="substituted" type="checkbox" aria-hidden="true"
                                        checked={isMp4Check}
                                        onChange={(e) => setIsMp4check(e.target.checked)}
                                      />
                                      <label className=" d-flex align-items-center" htmlFor={`mp4Check`}
                                        style={{ fontSize: '12px' }}
                                      >MP4</label>
                                    </div>
                                  </div>
                                  {!isVideoFormatSelect && (<div className='col-lg-8 col-6 d-flex align-items-center'>
                                    <h6 className="modal-head mb-0 text-start" style={{ fontSize: '12px', whiteSpace: 'nowrap', color: 'red', fontWeight: 'normal' }}>Please select Video format</h6>
                                  </div>)}
                                </div>

                              </div>

                            </div>


                            <div className='d-flex align-items-center gap-2'>
                              <button className="addButton add-index addButtonShare link-btns  mx-0 d-flex align-items-center gap-2"
                                style={{ top: 'unset' }}
                                onClick={() => {
                                  linkCopy(props.selectedVideoIds, "copy")

                                }
                                }
                              >
                                <FiLink size={17}
                                />Copy link
                                <div
                                  className="d-none position-absolute ms-0 mt-5 px-2 py-1 text-white bg-dark rounded"
                                  id="link-copy-common" style={{ fontSize: "10px", zIndex: 10, width: "53px" }}
                                >
                                  Copied!
                                </div>
                              </button>
                              <button className="addButton add-index addButtonShare link-btns mx-0 d-flex align-items-center gap-2"
                                style={{ top: 'unset' }} onClick={() => listSharePopup(props.selectedVideoIds, "mail")}
                              >
                                <FiMail size={17}
                                />Share by Email
                              </button>
                            </div>

                          </div>
                        </div>
                      </div>}
                    {
                      (videoIDsIndividual.length === 0 && props.userData?.roleDisplayName !== "User") && (
                        <button className="addButton add-index addButtonShare me-3"
                          onClick={() => {
                            url = `${window.location.href}share/${uuidv4()}`
                            setIsShareLink(true)
                            // const shareElement = document.getElementById("share-common");
                            // if (shareElement) {
                            //   shareElement.classList.toggle("d-none");
                            // }
                          }}>
                          <IoShareSocialOutline size={17} />
                        </button>
                      )
                    }
                  </>
                )}
                {isMultipleDownload &&
                  <div className="modal-admin-wrapper" >
                    <div className="modal-ad-popup modal-md">
                      <div className="modal-innerpopup ">
                        <span className="closeBtn"><IoCloseOutline size={32} onClick={() => cancelpopup()} /></span>
                        <div className="modal-headdiv d-flex justify-content-between">
                          <h5 className="modal-head">Download Files!</h5>
                          <div className="d-flex align-items-center gap-2 flex-wrap">
                            <div className="d-flex align-items-center gap-2"> <BiFile /><strong> {(selectedDownloadVideoMode === "Single" ? selectedDownloadVideo.length : selectedDownloadVideoALL.length)} file(s), {totalFileSize} </strong></div>
                          </div>
                        </div>
                        <div className="modal-admin-body my-3" style={{ maxHeight: 'calc(100vh - 290px)' }}>
                          <div className="table-responsive">

                            <table className="table table-bordered admin-list-table">
                              <tbody>
                                {(selectedDownloadVideoMode === "Single" ? selectedDownloadVideo : selectedDownloadVideoALL).map((data, i) => {

                                  return (
                                    < tr key={i} >
                                      <td style={{ width: '40%', minWidth: '250px' }} className='text-start'>{data.video_heading}{"." + data.file_extension}</td>
                                      <td style={{ width: '20%', minWidth: '100px' }} className='text-center'>
                                        {selectedQualities[data.video_id]?.size
                                          ? `${selectedQualities[data.video_id].size} MB`
                                          : (data.download_mp4 && !data.download_original) ? `${data.qualityTypeArray[0].qualityvideosize} MB` : `${data.size} MB`} </td>

                                      <td style={{ width: '40%', minWidth: '250px' }} className='text-center'>
                                        {props.userData.roleDisplayName === "User" &&
                                          // (data.downloadStatus === "APPROVED" ?
                                          <div className="d-flex align-items-center gap-3"
                                            style={{ color: '#00627B' }}
                                          >
                                            <select name="" id="" className='form-control form-select-drop'
                                              value={selectedQualities[data.video_id]?.quality || "Download Original"}
                                              onChange={(e) =>
                                                handleVideoQualityChange(data.video_id, e.target.value, data.qualityTypeArray)
                                              }
                                            >
                                              {(data.download_original || props?.userData?.hasFullAccess) &&
                                                <option value="Download Original" >Download Original</option>}
                                              {(data.download_mp4 || props?.userData?.hasFullAccess) &&
                                                data.qualityTypeArray.map((obj, j) => (
                                                  <option key={j} value={obj.qualitytype}>{obj.qualitytype}</option>
                                                ))}
                                            </select>

                                            <span style={{ flex: 'none' }} onClick={() => handleSingleDownload(data, selectedQualities[data.video_id])}>
                                              {/* {loadingStatusIndex === data.video_id ? "Downloading..." :  */}
                                              <FaDownload /></span>
                                          </div>
                                          // : "Waiting for Approval")
                                        }
                                        {['Admin', 'Super_admin'].includes((props.userData?.roleDisplayName)) &&

                                          <div className="d-flex align-items-center gap-3"
                                            style={{ color: '#00627B' }}
                                          >
                                            <select name="" id="" className='form-control form-select-drop'
                                              value={selectedQualities[data.video_id]?.quality || "Download Original"}
                                              onChange={(e) =>
                                                handleVideoQualityChange(data.video_id, e.target.value, data.qualityTypeArray)
                                              }
                                            >

                                              <option value="Download Original" >Download Original</option>
                                              {
                                                data.qualityTypeArray.map((obj, j) => (
                                                  <option key={j} value={obj.qualitytype}>{obj.qualitytype}</option>
                                                ))}
                                            </select>

                                            <span style={{ flex: 'none' }} onClick={() => handleSingleDownload(data, selectedQualities[data.video_id])}>
                                              {/* {loadingStatusIndex === data.video_id ? "Downloading..." :  */}
                                              <FaDownload /></span>
                                          </div>

                                        }
                                      </td>
                                    </tr>
                                  )
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="tag-popup-footer">
                          {!isDownloadBtn &&
                            <div className="d-flex align-items-center gap-2">
                              <button
                                type="button"
                                className="accept-all-btn w-100 py-2 accept-all-gray"
                                onClick={() => cancelpopup()}
                              >
                                Cancel
                              </button>

                              <button
                                type="button"
                                className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                                onClick={() => handleDownloadAll()}
                              >
                                Download all <BiDownload className="ms-0" />
                              </button>
                            </div>}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {isDelete &&
                  <div className="modal-admin-wrapper multiple-upload" >
                    <div className="modal-ad-popup modal-md">
                      <div className="modal-innerpopup ">
                        <div className="modal-headdiv d-flex justify-content-between">
                          <h5 className="modal-head w-100 text-center">Do you want to delete?</h5>
                          {/* <span className="closeBtn"><IoCloseOutline size={32} onClick={() => cancelpopup()} /></span> */}
                        </div>
                      </div>
                      <div className="tag-popup-footer">
                        <div className="d-flex align-items-center gap-2">
                          <button
                            type="button"
                            className="accept-all-btn w-100 py-2 accept-all-gray"
                            onClick={() => deletePopupCancel()}
                          >
                            Cancel
                          </button>

                          <button
                            type="button"
                            className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                            onClick={() => deleteList()}
                          >
                            Ok
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>}
                <div className='list-grid-btns'>
                  {props.destinationList.length > 0 && (
                    <>
                      <div
                        className={`list-grid-div ${viewType === 'grid' ? 'active' : ''}`}
                        onClick={() => dispatch(setViewType('grid'))}
                      >
                        <div className='grid-fill'>
                          <div className='grid-inner-fill'>
                            <div className='grid-dot-fill'></div>
                            <div className='grid-dot-fill'></div>
                            <div className='grid-dot-fill'></div>
                          </div>
                          <div className='grid-inner-fill'>
                            <div className='grid-dot-fill'></div>
                            <div className='grid-dot-fill'></div>
                            <div className='grid-dot-fill'></div>
                          </div>
                          <div className='grid-inner-fill'>
                            <div className='grid-dot-fill'></div>
                            <div className='grid-dot-fill'></div>
                            <div className='grid-dot-fill'></div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`list-grid-div ${viewType === 'list' ? 'active' : ''}`}
                        onClick={() => dispatch(setViewType('list'))}
                      >
                        <div className='list-bar'>
                          <div className='inner-list-bar'></div>
                          <div className='inner-list-bar'></div>
                          <div className='inner-list-bar'></div>
                        </div>
                      </div>
                    </>
                  )}
                  {(props.isAuthenticated && ['Admin', 'Super_admin'].includes((props.userData?.roleDisplayName))) &&
                    <button className="addButton add-index ms-3" onClick={() => listPopup("", "Add", "")}>
                      <GoPlus /> Add
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='position-relative'>
          <div className={`list  row g-4 ${viewType === 'grid' ? 'row-cols-1 row-cols-md-2 row-cols-lg-3' : 'row-cols-1 list-view-div col-xl-11'}`}>
            {props.destinationList.map((list, index) => (
              <div className="list-sub col" key={index} id={index}>
                {(props.isAuthenticated && (props.userData?.roleDisplayName !== "User")) &&
                  <div className='reject-sec-wrap'>
                    {((props.userData?.roleDisplayName === "Super_admin" || props.userData?.roleDisplayName === "APPROVER") && list.isApproved == 0 && list.approveStatus === "Open") &&
                      <div className='reject-sec'>
                        <button className="approveBtn"
                          id={`approveBtn` + index}
                          onClick={() => approveList(list)}>Approve</button>
                        <button className="rejectBtn" onClick={() => rejectPopup(list)}>Reject</button>
                      </div>
                    }
                    {((props.userData.roleDisplayName === "Admin") && (list.isApproved == 0) && (list.approveStatus === "Rejected")) &&
                      <div className='reject-sec'>
                        <span
                          className={`text-start w-100 reject-white ${viewType === 'list' ? 'reject-text' : ' '}`}
                        >Rejected: {list.rejected_reason}</span>
                      </div>
                    }
                  </div>
                }
                <div className='position-relative'>
                  <div className={`card ${viewType === 'grid' ? '' : 'list-view'}`}
                  >
                    <div className='position-relative loader-image-div'

                      onMouseEnter={() => {
                        handleMouseEnter(list)
                      }}
                      onMouseLeave={() => {
                        handleMouseLeave(list.video_id)
                      }}>

                      {/* {(!props.isAuthenticated || ((props.isAuthenticated && props.userData.roleDisplayName === "User"))) && (
                        <div className='download-sec'>
                          {props.userData.roleDisplayName === "User" &&
                            <div className='adminIconMainLt'>

                              <label className="custom-checkbox">
                                <input type="checkbox"
                                  name={list.filename}
                                  checked={selectedDownloadVideo.some(item => item.video_id === list.video_id)}
                                  onChange={(e) => handledownloadCheckboxChange(e, list)}
                                />
                                <span className="checkmark"></span>
                              </label>
                              <HiDownload className='list-download' size={18} id={`download-btn${index}`} onClick={() => downloadSingle(list, index)} />
                            </div>
                             } 

                          <div className='icon-download icon-loader' id={`loader-btn${index}`} style={{ display: "none" }}>
                            <div className="spinner-border text-white" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </div>
                       )} */}
                      {list.fileTypeId == "1" ?
                        <div className="position-relative image-container">
                          <img src={list.url} className="card-img-top card-video-img" alt="..."
                            style={{ backgroundColor: "#f1f1f1" }}
                            onContextMenu={(event) => event.preventDefault()}
                            onClick={() => {
                              popupTagShow(list)
                            }} />
                          <MdOutlineZoomOutMap className='img-zoom'
                            onClick={() => {
                              popupTagShow(list)
                            }} />
                        </div>
                        :
                        <>
                          <div>
                            <video
                              poster={list?.thumbnail_image}
                              key={list.video_id}
                              controls={hoveredVideoId === list.video_id}
                              controlsList="nodownload noremoteplayback"
                              onContextMenu={(event) => event.preventDefault()}
                              className="object-fit-contain w-100 card-video-img"
                              preload="metadata"
                              ref={(el) => {
                                videoRefs.current[list.video_id] = el;
                                if (el) {
                                  el.playbackRate = currentPlaybackRate;
                                  el.volume = (typeof volume === 'number' && !isNaN(volume) ? Math.min(Math.max(volume, 0), 1) : 1);
                                  el.muted = isMuted;
                                }
                              }}
                              onVolumeChange={handleVolumeChange}
                              onPlay={() => {
                                if (!props.isAuthenticated) {
                                  window.location.href = "/login";
                                }
                              }}
                            >
                              <source src="" type="video/mp4" />
                              Your browser does not support HTML5 video.
                            </video>
                          </div>

                          {hoveredVideoId === list.video_id && (
                            <>
                              <div className='position-relative'
                                ref={popupRef}
                              >
                                <button
                                  onClick={() => toggleSettings(list.video_id)}
                                  className="settings-btn-qta"
                                >
                                  <IoSettingsSharp className={`active-settings-btn ${activeSettings == list.video_id ? "active" : ''}`} />
                                </button>
                                {activeSettings == list.video_id && (
                                  <div className={`video-control-popup                              
                                  ${speedFlag && quality ? '' : 'active'}`}
                                  >
                                    <div className='show-playback-list'>
                                      <div className="playback-btn"
                                        onClick={() => showQuality()}
                                      >
                                        <MdTune />
                                        Quality
                                        <div className='popup-list-items'>
                                          <span className='popup-list-quality'>({selectedQuality}p)</span>
                                          <MdKeyboardArrowRight />
                                        </div>
                                      </div>
                                      <div className="playback-btn"
                                        onClick={() => showSpeed()}
                                      >
                                        <MdOutlinePlayCircle />
                                        Playback speed
                                        <div className='popup-list-items'>
                                          {currentPlaybackRate}
                                          <MdKeyboardArrowRight />
                                        </div>
                                      </div>
                                      <div className="playback-btn" onClick={() => handlePiP(list.video_id)}>
                                        {pipVideoId === list.video_id
                                          ? <>
                                            <MdCloseFullscreen />
                                            Exit PiP
                                          </>
                                          : <>
                                            <MdPictureInPicture />
                                            Picture-in-Picture
                                          </>
                                        }
                                      </div>
                                    </div>

                                    <div ref={dropdownRef} className={`quality-dropdown-qta ${quality ? '' : 'active'}`}>
                                      <div className='playback-btn palback-back-div'
                                        onClick={() => backToQuality()}
                                      >
                                        <MdKeyboardArrowLeft />
                                        Quality
                                      </div>
                                      {list?.qualityTypeArray?.map((qualityItem) => (
                                        <p key={qualityItem.qualitytype} className="quality-dropdown-p"
                                          onClick={() => handleQualityChange(qualityItem.qualitytype)}>
                                          <input
                                            type="radio"
                                            id={`${list.video_id}-${qualityItem.qualitytype}`}
                                            className="quality-radio-input"
                                            name="global-quality"
                                            value={qualityItem.qualitytype}
                                            checked={selectedQuality === qualityItem.qualitytype}
                                            onChange={() => handleQualityChange(qualityItem.qualitytype)}
                                          />
                                          <label htmlFor={`${list.video_id}-${qualityItem.qualitytype}`}>{qualityItem.qualitytype}</label>
                                        </p>
                                      ))}
                                    </div>

                                    <div className={`show-playback-items ${speedFlag ? '' : 'active'}`}>
                                      <div className='playback-btn palback-back-div'
                                        onClick={() => backToList()}
                                      >
                                        <MdKeyboardArrowLeft />
                                        Playback speed
                                      </div>

                                      {speeds.map((s) => (
                                        <div
                                          key={s.value}
                                          className={`playback-btn ${currentPlaybackRate === s.value ? 'selected' : ''}`}
                                          onClick={() => {
                                            handlePlaybackRateChange(s.value, list.video_id);
                                          }}
                                        >
                                          {s.label}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                        </>
                      }
                    </div>
                    <div
                      className={`card-body ${viewType === "list" &&
                        ((!props.isAuthenticated) || (props.isAuthenticated && props.userData?.roleDisplayName === "User"))
                        ? "pt-4"
                        : ""
                        }`}
                    >

                      {(props.isAuthenticated) &&
                        <div className="adminIconMain">
                          <div className='adminIconMainLt'>
                            {(props.userData.roleDisplayName !== "User") && (
                              <button className="editIcon mb-0">
                                {list.userDisplayName}
                              </button>
                            )}

                            {((props.userData?.roleDisplayName === "Admin" || props.userData?.roleDisplayName === "Super_admin" || props.userData?.roleDisplayName === "User") && list.approveStatus !== "Rejected") &&
                              <label className="custom-checkbox">
                                <input type="checkbox"
                                  name={list.filename}
                                  checked={props.selectedVideoIds.includes(list.video_id)}
                                  onChange={(e) => handleCheckboxChange(e, list.video_id, list.fileTypeId, list)}
                                />
                                <span className="checkmark"></span>
                              </label>
                            }
                          </div>
                          {popupShareStates[index] &&
                            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }} className='share-icons'
                              ref={shareIconsRef}>
                            </div>
                          }
                          <div className='adminIconMainRt position-relative'>
                            {(props.userData?.roleDisplayName === "Admin" || props.userData?.roleDisplayName === "Super_admin") &&
                              <>
                                {activeShareIndex === index && (
                                  <div ref={popupRefList} className="icons-popup">
                                    <button className="popupIcon"
                                      onClick={() => listSharePopup([list.video_id], "mail", list, index)}>
                                      <FiMail />
                                    </button>
                                    <button className="popupIcon"
                                      onClick={() => linkCopy([list.video_id], "copy", list, index)}>
                                      <FiLink />
                                      {copiedIndex === list.video_id && (
                                        <div
                                          className="position-absolute ms-4 mt-1 px-2 py-1 text-white bg-dark rounded"
                                          style={{ fontSize: "10px", zIndex: 10, width: "53px" }}
                                        >
                                          Copied!
                                        </div>
                                      )}
                                    </button>
                                  </div>
                                )}

                                {list.approveStatus !== "Rejected" && (
                                  <>
                                    <button className="editIcon"
                                      onClick={() => {
                                        setVideoIDsIndividual([list.video_id])
                                        props.setSelectedVideoIds([])
                                        setIsShareLink(true)
                                        if (list.fileType == "Video") {
                                          setHasVideo(true)

                                        } else {
                                          setHasVideo(false)
                                        }
                                        // setActiveShareIndex(prev => (prev === index ? null : index))
                                        url = `${window.location.href}share/${uuidv4()}`
                                      }}>

                                      <IoShareSocialOutline size={17} />
                                    </button>
                                    <button className="editIcon" onClick={() => listPopup(list, "Edit", index)}>
                                      <FiEdit2 size={17} />
                                    </button>
                                  </>
                                )}
                                <button className="editIcon"
                                  onClick={() => {
                                    setSelectedToDelete(list);
                                    setIsDelete(true)
                                    // deleteList(list)
                                  }}>
                                  <RiDeleteBinLine size={17} />
                                </button>

                                {/* {(!props.isAuthenticated || ((props.isAuthenticated && props.userData.roleDisplayName !== "APPROVER"))) && (
                                  <div className='download-sec'>
                                    <HiDownload className='list-download' size={18} id={`download-btn${index}`} onClick={() => downloadFn(list, index)} />
                                    <div className='icon-download icon-loader' id={`loader-btn${index}`} style={{ display: "none" }}>
                                      <div className="spinner-border text-white" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                      </div>
                                    </div>
                                  </div>
                                )} */}
                              </>
                            }
                            {(!props.isAuthenticated || ((props.isAuthenticated && props.userData.roleDisplayName !== "APPROVER")) && list.approveStatus !== "Rejected") && (
                              <button className="editIcon">
                                <HiDownload size={17}
                                  id={`download-btn${index}`} onClick={() => downloadSingle(list, index)}

                                //onClick={() => downloadFn(list, index)} 
                                />
                                <div className='icon-download icon-loader' id={`loader-btn${index}`} style={{ display: "none" }}>
                                  <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                  </div>
                                </div>
                              </button>
                            )}
                          </div>
                        </div>
                      }
                      {((viewType === "list") && ((!props.isAuthenticated) || (props.isAuthenticated && props.userData?.roleDisplayName === "User"))) &&
                        <div className='col-md-12 listBtnDiv'>
                          {list.fileType && <span className="listBtnView">
                            {list.fileType == "Video" ? <GrMultimedia /> : <MdOutlinePermMedia />}
                            {list.fileType}
                          </span>}
                          {list.videoCreatedOn && <span className="listBtnView"><CiCalendarDate />{list.video_date ? moment(list.video_date).format('DD-MM-YYYY') : list.videoCreatedOn}</span>}
                          {list.video_location && <span className="listBtnView"><IoLocationOutline />{list.video_location}</span>}
                          {list.size && <span className="listBtnView"><IoIosResize />{list.size}</span>}
                        </div>
                      }
                      <h5 className="card-title" title={list.video_heading}>{list.video_heading}</h5>
                      <p className="card-text">{list.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {props.loading &&
            <div className="d-flex flex-column text-center">
              <div>
                <img src={Loader} alt="noData" className="img-fluid" width="100" height="100" />
              </div>
            </div>
          }
          {props.hasMore && <div className='' id='load-more-trigger'></div>}
        </div>
      </div>
      {tagPopupFlag &&
        <ListPopup cancelPopup={cancelPopup} userData={props.userData} isAuthenticated={props.isAuthenticated}
          selectedData={selectedData}
        />
      }
      {popupList &&
        <ListUpload userData={props?.userData}
          cancelPopup={cancelPopup} getData={props.getData} getCloudBucketData={props.getCloudBucketData}
          sendMail={sendMail} selectData={selectData} mode={mode} selectIndex={selectIndex} />
      }

      {popupReject &&
        <ListReject rejectData={rejectData} userData={props?.userData}
          cancelPopup={cancelPopup} getData={props.getData}
          sendMail={sendMail} />
      }
    </div>
  );
}

export default List;